import { Link, Outlet } from 'react-router'
import logoUrl from '#app/assets/favicons/favicon.svg'

export default function AuthLayout() {
	return (
		<div className="min-h-screen bg-[#18181b] text-[#e4e4e7]">
			{/* Nav */}
			<header className="glass-header fixed top-0 z-50 flex h-16 w-full items-center justify-between px-6">
				<Link
					to="/"
					className="font-display flex items-center gap-2 text-[10px] text-neon-pink"
				>
					<img src={logoUrl} alt="" className="h-6 w-6" />
					MUZIEKDOCENT
				</Link>
				<div className="flex items-center gap-4">
					<Link
						to="/login"
						className="text-sm text-text-muted transition-colors duration-150 hover:text-white"
					>
						Inloggen
					</Link>
					<Link
						to="/signup"
						className="rounded-lg bg-violet-600 px-4 py-2 text-sm font-medium text-white shadow-[0_0_15px_rgba(139,92,246,0.3)] transition-colors duration-150 hover:bg-violet-500"
					>
						Registreren
					</Link>
				</div>
			</header>

			{/* Content */}
			<main className="pt-16">
				<Outlet />
			</main>
		</div>
	)
}
